import { endpoints } from 'constants/endpoints';

import { sendRequest } from '../sendRequest';

export const getFiltersApi = () => {
  const url = endpoints.analytics.review.filters;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getReviewCyclesAndCalibrationViewsApi = ({ cohortId, isPlanOfAction }) => {
  const url = isPlanOfAction
    ? endpoints.analytics.review.reviewCyclesActionPlanPublished
    : endpoints.analytics.review.reviewCyclesAndCalibrationViews;
  return sendRequest({
    url,
    queryParams: isPlanOfAction ? null : { cohortId },
    credentials: 'include',
  });
};

export const getPublishedReviewCyclesActionPlanApi = () => {
  const url = endpoints.analytics.review.reviewCyclesActionPlanPublished;
  return sendRequest({
    url,
    credentials: 'include',
  });
};

/**
 * @deprecated 06-08-2024
 */
export const getCountsApi = ({ cohort, groupByKeys, source }) => {
  const url = endpoints.analytics.review.count;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      source,
    },
  });
};

export const getAggregatedCountApi = ({ cohort, groupByKeys, source }) => {
  const url = endpoints.analytics.review.aggregatedCount;
  // https://linear.app/peoplemesh/issue/ENG-17343/update-review-page-apis-request-to-filter-reviewtype
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { reviewType, ...sourceWithoutReviewType } = source ?? {};
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      source: sourceWithoutReviewType,
    },
  });
};

export const getTabularDataApi = ({ cohort, groupByKeys, source, filter, orderBy }) => {
  const url = endpoints.analytics.review.tabularData;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      source,
      filter,
      orderBy,
    },
  });
};

export const getCalibrationTabularDataApi = ({ cohort, groupByKeys, source, filter, orderBy }) => {
  const url = endpoints.analytics.review.calibration.tabularData;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      source,
      filter,
      orderBy,
    },
  });
};

// export const getInceDataApi = ({ cohort, groupByKeys, source, filter, orderBy }) => {
//   let url = endpoints.analytics.review.calibration.tabularData;
//   return sendRequest({
//     url,
//     method: 'POST',
//     credentials: 'include',
//     body: {
//       cohortId: cohort?.id,
//       groupByKeys,
//       source,
//       filter,
//       orderBy
//     }
//   });
// };

export const recalibrateApi = ({
  employeeId,
  reviewId,
  feedbackFormId = null,
  isReopenManagerResponse = false,
  columnId,
  reason,
  value,
}) => {
  const url = endpoints.analytics.review.calibration.recalibrate(employeeId);
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      reviewCycleId: reviewId,
      feedbackFormId: feedbackFormId ?? null,
    },
    body: {
      columnId,
      reason,
      value,
      isReopenManagerResponse,
    },
  });
};

export const barGraphDataApi = ({ cohort, reviewCycleId }) => {
  const url = endpoints.analytics.review.calibration.barGraph;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      reviewCycleId,
    },
  });
};

export const performanceGridDataApi = ({ cohort, groupByKeys, source, filter, type }) => {
  const url = endpoints.analytics.review.calibration.performanceGridV1;
  // https://linear.app/peoplemesh/issue/ENG-17343/update-review-page-apis-request-to-filter-reviewtype
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { reviewType, ...sourceWithoutReviewType } = source ?? {};
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      reviewCycleId: source?.id,
    },
  });
};

export const getCohortValues = ({ pageType, reviewId }) => {
  const url = endpoints.analytics.review.cohort.values;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      pageType,
      reviewCycleId: reviewId,
    },
  });
};

export const createCohort = ({ cohortName, query, baseCohort, visibilityType }) => {
  const url = endpoints.analytics.review.cohort.save;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      name: cohortName,
      query,
      baseCohort,
      visibilityType,
    },
  });
};

/**
 * @deprecated 06-08-2024
 */
export const generateCSVDataApi = ({ cohort, groupByKeys, source, filter, orderBy }) => {
  const url = endpoints.analytics.review.generateFile;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      source,
      filter,
      orderBy,
    },
  });
};

/**
 * @deprecated 06-08-2024
 */
export const generateCalibrationCSVDataApi = ({ cohort, groupByKeys, source, filter, orderBy }) => {
  const url = endpoints.analytics.review.calibration.generateFile;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      source,
      filter,
      orderBy,
    },
  });
};

export const getCSVGenerationStatusApi = (requestIds) => {
  const url = endpoints.analytics.review.fileGenerationStatus;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      requestIds,
    },
  });
};

export const downloadCSVApi = (requestId) => {
  const url = endpoints.analytics.review.downloadFile(requestId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const getReviewCycleStageApi = ({ reviewCycleId }) => {
  const url = endpoints.analytics.review.reviewCycleStage;
  return sendRequest({
    url,
    credentials: 'include',
    queryParams: {
      review_cycle_id: reviewCycleId,
    },
  });
};

export const triggerPDFReportGenerationApi = ({
  reviewId,
  employeeId,
  providerId,
  responseId,
  receiverEmail,
  reportView,
  isDeerUI,
  reportViewerPersona,
  employeeEmail,
}) => {
  const url = endpoints.analytics.review.generateReviewSummaryPDF;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      reviewId,
      empId: employeeId,
      providerId,
      responseId,
      receiverEmail,
      reportView,
      isDeerUI,
      reportViewerPersona,
      employeeEmail,
    },
  });
};

export const getPerformanceReviewApi = ({ empId }) => {
  const url = endpoints.analytics.review.performanceReviewGraph;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      empId,
    },
  });
};

// Rabbit APIs

export const getReviewsManageFilterDataApi = ({ cohort, filterApi }) => {
  const url = endpoints.performanceReview.manage.filterData;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      filterApi,
    },
  });
};

/**
 * @deprecated 06-08-2024
 */
export const downloadInsightsTableCSVReportApi = ({
  cohort,
  groupByKeys,
  dateRange,
  filter,
  orderBy,
  groupFilter,
  attributeFilter,
  filterApi,
  offset,
  limit,
}) => {
  const url = endpoints.performanceReview.insights.insightsTableCSVReport;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: {
      cohortId: cohort?.id,
      groupByKeys,
      dateRange,
      filter,
      orderBy,
      groupFilter,
      attributeFilter,
      filterApi,
      offset,
      limit,
    },
  });
};

export const getCalibrationRecomputeApiV1 = (requestBody) => {
  const url = endpoints.performanceReview.manage.calibrationRecomputeV1;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: requestBody,
  });
};

export const postReviewRecalibrationSaveApi = (requestBody) => {
  const url = endpoints.performanceReview.reviewManage.recalibrate;
  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body: requestBody,
  });
};

export const reopenReviewFormApi = ({ receiverEmployeeId, providerEmployeeId, reviewCycleId }) => {
  const url = endpoints.performanceReview.manage.reopenReviewForm;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      receiverEmployeeId,
      providerEmployeeId,
      reviewCycleId,
    },
  });
};

export const manageTableCSVReportApi = ({ type, requestBody }) => {
  const url = endpoints.performanceReview.manage.manageTableCSVReport(type);
  const { cohort, ...rest } = requestBody;
  const body = {
    ...rest,
  };

  body.cohortId = cohort?.id;

  return sendRequest({
    url,
    method: 'POST',
    credentials: 'include',
    body,
  });
};

export const forceSubmitApi = ({ providerEmployeeId, receiverEmployeeId, reviewCycleId, providerType }) => {
  const url = endpoints.performanceReview.manage.forceSubmit;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      providerEmployeeId,
      receiverEmployeeId,
      reviewCycleId,
      providerType,
    },
  });
};

export const notifyApi = ({ feedbackFormId, receiverEmployeeId, providerEmployeeId, providerType }) => {
  const url = endpoints.performanceReview.manage.notify;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      feedbackFormId,
      receiverEmployeeId,
      providerEmployeeId,
      providerType,
    },
  });
};

export const getReviewManageSingleRowTabularDataApi = ({ reviewCycleId, empId }) => {
  const url = endpoints.performanceReview.reviewManage.singleRowData;

  return sendRequest({
    url,
    credentials: 'include',
    queryParams: { reviewCycleId, empId },
  });
};
